import { languages } from "@codeshare/languages";
import type { Runner } from "@codeshare/runner-core";
import { goRunner } from "@codeshare/runner-go";
import { javascriptRunner } from "@codeshare/runner-javascript";
import { ocamlRunner } from "@codeshare/runner-ocaml";
import { pythonRunner } from "@codeshare/runner-python";
import { rubyRunner } from "@codeshare/runner-ruby";

/** Runners by id (a language descriptor's `runner` field). Each loads its runtime lazily. */
export const RUNNERS: Record<string, Runner> = {
  javascript: javascriptRunner,
  python: pythonRunner,
  ruby: rubyRunner,
  go: goRunner,
  ocaml: ocamlRunner,
};

/** The runner for a language, if it has one here. */
export function runnerFor(languageId: string): Runner | undefined {
  const id = languages.get(languageId)?.runner;
  return id ? RUNNERS[id] : undefined;
}
